if (!customElements.get('product-details')) {
  customElements.define(
    'product-details',
    class ProductDetails extends HTMLElement {
      connectedCallback() {
        this.unsubscribeVariantChange?.();
        if (!window.FoxTheme?.pubsub?.subscribe) return;

        this.unsubscribeVariantChange = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.unsubscribeVariantChange?.();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant) return;

        const productUrl = this.dataset.url;
        const sectionId = this.dataset.section;
        if (!productUrl || !sectionId) return;

        const url = `${productUrl}?section_id=${sectionId}&variant=${variant.id}`;

        fetch(url)
          .then((res) => res.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const newNode = html.getElementById(this.id);
            if (!newNode) return;

            if (window.HTMLUpdateUtility?.viewTransition) {
              HTMLUpdateUtility.viewTransition(this, newNode);
            } else {
              this.innerHTML = newNode.innerHTML;
            }
          })
          .catch((error) => console.error('ProductDetails update error:', error));
      }
    }
  );
}
